var map = {
	"./absenteeism of-sweeper": 1967,
	"./absenteeism of-sweeper.js": 1967,
	"./account-alert": 1968,
	"./account-alert.js": 1968,
	"./accumulation-of-litter": 1969,
	"./accumulation-of-litter.js": 1969,
	"./animals": 1970,
	"./animals.js": 1970,
	"./birth-death": 1971,
	"./birth-death.js": 1971,
	"./blood-bank": 1972,
	"./blood-bank.js": 1972,
	"./calendar": 1973,
	"./calendar.js": 1973,
	"./check-circle": 1974,
	"./check-circle.js": 1974,
	"./circle": 1975,
	"./circle.js": 1975,
	"./closed-complaints": 1976,
	"./closed-complaints.js": 1976,
	"./comment-plus": 1977,
	"./comment-plus.js": 1977,
	"./dashboard-complaint": 1978,
	"./dashboard-complaint.js": 1978,
	"./dashboard-propertytax": 1979,
	"./dashboard-propertytax.js": 1979,
	"./drains": 1980,
	"./drains.js": 1980,
	"./edcr": 1981,
	"./edcr.js": 1981,
	"./facebook": 1982,
	"./facebook.js": 1982,
	"./file-check": 1983,
	"./file-check.js": 1983,
	"./file-download": 1984,
	"./file-download.js": 1984,
	"./file-plus": 1985,
	"./file-plus.js": 1985,
	"./file-send": 1986,
	"./file-send.js": 1986,
	"./filter": 1987,
	"./filter.js": 1987,
	"./fire": 1988,
	"./fire-station": 1989,
	"./fire-station.js": 1989,
	"./fire.js": 1988,
	"./footpaths": 1990,
	"./footpaths.js": 1990,
	"./garbage": 1991,
	"./garbage-bin-absent": 1992,
	"./garbage-bin-absent.js": 1992,
	"./garbage-burn": 1993,
	"./garbage-burn.js": 1993,
	"./garbage-dump": 1994,
	"./garbage-dump.js": 1994,
	"./garbage.js": 1991,
	"./hamburger": 1995,
	"./hamburger.js": 1995,
	"./help-circle": 1996,
	"./help-circle.js": 1996,
	"./home-account": 1997,
	"./home-account.js": 1997,
	"./home-city-outline": 1998,
	"./home-city-outline.js": 1998,
	"./hospital": 1999,
	"./hospital.js": 1999,
	"./landviolations": 2000,
	"./landviolations.js": 2000,
	"./library-books": 2001,
	"./library-books.js": 2001,
	"./licenses": 2002,
	"./licenses.js": 2002,
	"./localShipping": 2003,
	"./localShipping.js": 2003,
	"./location-pin": 2004,
	"./location-pin.js": 2004,
	"./map-marker": 2005,
	"./map-marker.js": 2005,
	"./mosquitos": 2006,
	"./mosquitos.js": 2006,
	"./my-complaint": 2007,
	"./my-complaint.js": 2007,
	"./notifications": 2008,
	"./notifications.js": 2008,
	"./open-complaints": 2009,
	"./open-complaints.js": 2009,
	"./opendefecation": 2010,
	"./opendefecation.js": 2010,
	"./others": 2011,
	"./others.js": 2011,
	"./overflowing-garbage": 2012,
	"./overflowing-garbage.js": 2012,
	"./parks": 2013,
	"./parks.js": 2013,
	"./police-station": 2014,
	"./police-station.js": 2014,
	"./property-tax": 2015,
	"./property-tax.js": 2015,
	"./pt-example": 2016,
	"./pt-example.js": 2016,
	"./publictoilets": 2017,
	"./publictoilets.js": 2017,
	"./reassign-request": 2018,
	"./reassign-request.js": 2018,
	"./road-man-hole": 2019,
	"./road-man-hole.js": 2019,
	"./roads": 2020,
	"./roads.js": 2020,
	"./roadsandfootpaths": 2021,
	"./roadsandfootpaths.js": 2021,
	"./rupee": 2022,
	"./rupee.js": 2022,
	"./streetlights": 2023,
	"./streetlights.js": 2023,
	"./timeline-assigned-icon": 2024,
	"./timeline-assigned-icon.js": 2024,
	"./trade-license": 2025,
	"./trade-license.js": 2025,
	"./trees": 2026,
	"./trees.js": 2026,
	"./twitter": 2027,
	"./twitter.js": 2027,
	"./water": 2028,
	"./water-pump": 2029,
	"./water-pump.js": 2029,
	"./water-tap": 2030,
	"./water-tap.js": 2030,
	"./water.js": 2028,
	"./waterandsewage": 2031,
	"./waterandsewage.js": 2031,
	"./whatsapp": 2032,
	"./whatsapp.js": 2032
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2220;


//////////////////
// WEBPACK FOOTER
// ./node_modules/egov-ui-kit/custom-icons ^\.\/.*$
// module id = 2220
// module chunks = 1137